import React from "react";
import Marquee from "react-fast-marquee";

import iciciBankImg from '../Img/ICICI_Bank_Logo.svg.png';
import hdfcBankImg from '../Img/HDFC-Bank-logo.png';
import sbiBankImg from '../Img/State_Bank_of_India_logo.png';
import idfcBankImg from '../Img/Logo_of_IDFC_First_Bank.png';
import kotakBankImg from '../Img/Kotak_Mahindra_Group_logo.png';
import bankofmaharashtraImg from '../Img/Bank_of_Maharashtra_logo.png';
import bankofbarodaImg from '../Img/Bank_of_Baroda_logo.png';
import axisbankImg from '../Img/Axis_Bank_logo.png';
import unionbankImg from '../Img/Union_Bank_of_India_Logo.png';
import punjabBankImg from '../Img/punjab_bank_logo.png';

const bankLogos = [
  iciciBankImg,
  hdfcBankImg,
  sbiBankImg,
  idfcBankImg,
  kotakBankImg,
  bankofmaharashtraImg,
  bankofbarodaImg,
  axisbankImg,
  unionbankImg,
  punjabBankImg,
];

const Associates = () => {
  return (
    <div className="loan-card-main" style={{ overflowX: "hidden", maxWidth: "89%", margin: "0 auto" }}>
      <h2 className="sections-title-smco">
        <span className="horizontal-line"></span>We Are Associated With
      </h2>

      <p className="sections-description-smco">
        We are associated with all major private, government banks, and NBFCs. Below are a few of the banks we work with to provide you the best loan options:
      </p>

      {/* Wrapper to limit width and prevent overflow */}
      <div style={{ overflowX: "hidden", maxWidth: "100%", margin: "0 auto" }}>
        <Marquee
          gradient={false}
          speed={40}
          pauseOnHover={true}
          className="bank-marquee"
        >
          {bankLogos.map((src, idx) => (
            <div key={idx} style={{ margin: "0 2rem", flexShrink: 0 }}>
              <img
                src={src}
                alt={`bank-${idx}`}
                style={{
                  maxWidth: "150px",
                  maxHeight: "60px",
                  objectFit: "contain",
                  transition: "filter 0.3s ease",
                }}
                onMouseOver={e => (e.currentTarget.style.filter = "none")}
                onMouseOut={e => (e.currentTarget.style.filter = "grayscale(100%)")}
              />
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default Associates;
